module.exports = __webpack_public_path__ + "static/img/Sheng-Kai Hsu.jpg";